var render = function render(){var _vm=this,_c=_vm._self._c;return _c('warning-modal',{staticClass:"forbidden-ingredient-warning-modal",attrs:{"name":"forbidden-ingredient-warning-modal"},on:{"confirm":_vm.onConfirm,"before-open":_vm.onBeforeOpen},scopedSlots:_vm._u([{key:"main-content",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('dashboard.microneedling.warning.glycolic'))+" ")]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }